import { buildHostedPairingUrl } from "../../hostedPairing";
import { setPairingTokenOnUrl } from "../../pairingUrl";

export function resolveDesktopPairingUrl(endpointUrl: string, credential: string): string {
  const url = new URL(endpointUrl);
  url.pathname = "/pair";
  return setPairingTokenOnUrl(url, credential).toString();
}

/**
 * The hosted share link for a pairing code, or null when this build has no
 * hosted app to send a user to. This fork runs no hosted web app, and
 * buildHostedPairingUrl falls back to the source project's default origin
 * when VITE_HOSTED_APP_URL is unset, so an ungated call renders their domain
 * into every share link and QR code in Authorized clients. Callers already
 * treat null as "use resolveDesktopPairingUrl", which hands out this
 * machine's own /pair URL and works over the tailnet.
 */
export function resolveHostedPairingUrl(endpointUrl: string, credential: string): string | null {
  if (!import.meta.env.VITE_HOSTED_APP_URL?.trim()) {
    return null;
  }

  const url = new URL(endpointUrl);
  if (url.protocol !== "https:") {
    return null;
  }

  return buildHostedPairingUrl({
    host: endpointUrl,
    token: credential,
  });
}
